import React from "react";
import { Sidebar } from "../components/Sidebar";
import { MobileBottomNavSpacer } from "../components/MobileBottomNav";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Placeholder({ title, subtitle }) {
  return (
    <div
      className="min-h-screen flex"
      style={{ background: "linear-gradient(180deg, #050715 0%, #07091B 60%, #07091B 100%)", color: "#E2E8F0" }}
    >
      <Sidebar />
      <main
        className="md:ml-[var(--cf-sidebar-w,300px)] transition-[margin-left] duration-300 ease-out flex-1 flex items-center justify-center min-h-screen px-8 relative"
        data-testid={`placeholder-${title}`}
      >
        {/* Subtle ambient lighting */}
        <span aria-hidden="true" className="absolute top-0 right-0 w-[520px] h-[360px] rounded-full blur-3xl pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(99,102,241,0.10), transparent 70%)" }} />
        <span aria-hidden="true" className="absolute bottom-0 left-0 w-[420px] h-[320px] rounded-full blur-3xl pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(139,92,246,0.08), transparent 70%)" }} />

        <div className="max-w-[560px] text-center relative z-10">
          <span
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10.5px] font-semibold uppercase tracking-[0.22em]"
            style={{
              background: "rgba(139,92,246,0.10)",
              border: "1px solid rgba(139,92,246,0.22)",
              color: "#C4B5FD",
            }}
          >
            <Sparkles size={11} /> In design · Q2 2026
          </span>
          <h1
            className="font-display text-[42px] sm:text-[56px] font-bold tracking-[-0.03em] mt-6 leading-[1.05]"
            style={{ color: "#FFFFFF" }}
          >
            {title}
          </h1>
          <p className="text-[14px] sm:text-[15px] mt-4 leading-relaxed" style={{ color: "#94A3B8" }}>
            {subtitle}
          </p>
          <Link
            to="/dashboard"
            data-testid="back-to-dashboard-link"
            className="mt-8 inline-flex items-center gap-2 h-11 px-5 rounded-xl text-white text-[13.5px] font-semibold transition-transform active:scale-95"
            style={{
              background: "linear-gradient(135deg, #8B5CF6 0%, #6366F1 100%)",
              boxShadow: "0 16px 32px -10px rgba(99,102,241,0.55)",
            }}
          >
            Back to Overview <ArrowRight size={14} />
          </Link>
        </div>
        <MobileBottomNavSpacer />
      </main>
    </div>
  );
}
